import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}
@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {

  @Input() text = '';
  @Input() carId = '';
  // @Input() src = 'Personal';

  constructor(private translate: TranslateService) {
    // Load the Facebook SDK asynchronously
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  ngOnInit(): void {
  }

  get websiteUrl() {
    return 'https://customer.slickchain.com' + encodeURIComponent(`/car-overview?url=car-market&id=` + this.carId.toString());
  }

  // get twitter() {
  //   return `http://twitter.com/share?text=text goes here&url=${this.websiteUrl}&hashtags=hashtag1,hashtag2,hashtag3`;
  // }

  // get facebook() {
  //   const url = `http://localhost:4500/car-overview/817281`;
  //   return `https://www.facebook.com/sharer/sharer.php?u=${this.websiteUrl}&src=sdkpreparse`;
  // }

  get header() {
    return this.translate.instant('SHARE.HEADER');
  }

  get pageTitle() {
    return ` ${this.header} ${this.text} (${this.carId})
    `;
  }

  shareFacebookUrl() {
   // URL and text to share
   const urlToShare = 'https://example.com';
   const textToShare = 'Check out this awesome website!';

   // Use the Facebook SDK to open the share dialog
   if (window.FB) {
     window.FB.ui({
       method: 'share',
       href: urlToShare,
       quote: textToShare
     }, function(response){});
   }
   return false
  }

  shareTweetUrl() {
    window.open('http://twitter.com/share?text=' +
      encodeURIComponent(this.pageTitle) +
      'url=' + this.websiteUrl +
      '&hashtags=hashtag1,hashtag2,hashtag3');
    return false;
  }

  shareMailUrl() {
    window.open('mailto:?subject=' +
      encodeURIComponent(this.pageTitle) +
      '&body=' +
      encodeURIComponent(this.pageTitle) +
      this.websiteUrl);
    return false;
  }

  shareInstaUrl() {
    window.open('https://instagram.com/accounts/login/?text=' +
    encodeURIComponent(this.pageTitle) +
    encodeURIComponent(this.websiteUrl));
    return false;
  }

  shareWhatsapp() {
    window.open('https://wa.me?text=' +
      encodeURIComponent(this.pageTitle) +
      this.websiteUrl);
      return false;
  }

  // 'https://twitter.com/intent/tweet?text' +

}
